import {inject} from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { EventService } from "@services";
import { EventItem } from "@model";

export const NewEventsResolver: ResolveFn<Observable<EventItem[]>> = (route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  eventService: EventService = inject(EventService)): Observable<EventItem[]> => {
    return eventService.findNewEventsList();
}
